import React, { useEffect, useState, useContext } from 'react'
import { useHistory, useLocation } from 'react-router'
import ConfigContext from '../ConfigContext'
import axios from 'axios'
import queryString from 'query-string'
import FlatPagination from 'material-ui-flat-pagination'
import moment from 'moment-timezone'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import store from '../store'
import { setSearchQuery, unsetSearchQuery } from '../store/actions/searchQuery'
import { setDialog } from '../store/actions/dialog'
import {
  Grid,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Avatar,
  Typography,
  Chip,
  Badge,
  Link
} from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import CancelIcon from '@material-ui/icons/Close'
import { ErrorRounded } from '@material-ui/icons'
import Title from '../components/atoms/Title'
import SelectInputTableHead from '../components/atoms/SelectInputTableHead'
import ValidationAndLimitLengthInput from '../components/atoms/ValidationAndLimitLengthInput'
import DatePeriodFragment from '../components/molecules/DatePeriodFragment'
import RightSideSubmitButton from '../components/molecules/RightSideSubmitButton'
import WebViewModal from '../components/organisms/WebViewModal'
import NotificationPushModal from '../components/organisms/NotificationPushModal'
import { Notification } from '../types/Notification'
import { User } from '../types/User'
import { Category } from '../types/Category'

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    height: `100%`
  },
  paper2: {
    padding: theme.spacing(2),
    display: 'flex',
    overflowY: 'hidden',
    flexDirection: 'column',
    height: `100%`
  },
  textField: {
    paddingRight: theme.spacing(1)
  },
  avatar: {
    width: 60,
    height: 60,
    borderRadius: 0
  },
  tableBody: {
    '& .MuiTableCell-sizeSmall': {
      padding: '0.8rem 6px'
    }
  },
  tableHead: {
    '& .MuiTableCell-sizeSmall': {
      padding: '4px 6px'
    }
  },
  table: {
    wordBreak: 'break-all',
    wordWrap: 'break-word'
  },
  badge: {
    '& .MuiBadge-badge': {
      height: 'auto',
      padding: 3,
      borderRadius: '50%',
      backgroundColor: '#FF6363',
      color: '#fff'
    }
  }
}))

type QueryString = {
  sort?: string
  order?: 'asc' | 'desc'
  page?: string
  limit?: string
  sender?: string
  category?: string
  important_flg?: string
  hot_news_flg?: string
  close_flg?: string
  post?: string
  push?: string
}
type UserWithMessageInfo = User & { unread: number; user_unread: number; message_count: number }
type MessageUserSearchResponse = {
  number_of_hits: number
  users: UserWithMessageInfo[]
  app_name: string
  unread_total: number
}

const Notifications: React.FC<
  ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>
> = ({ setDialog, setSearchQuery, unsetSearchQuery, searchQuery }) => {
  const fetchLimit = 100
  const history = useHistory()
  const location = useLocation()
  const initQuery: QueryString = queryString.parse(location.search)
  const [total, setTotal] = useState<number>(0)
  const [limit, setLimit] = useState<number>(fetchLimit)
  const classes = useStyles({})
  const [notifications, setNotifications] = useState<Notification[]>([])
  const [pushMessage, setPushMessage] = useState('新しいお知らせがあります。')
  const [validateState, setValidateState] = useState(false)
  const [modalState, setModalState] = useState(false)
  const [modalStatePush, setModalStatePush] = useState({
    notificationId: null,
    isOpen: false
  })
  const [webViewUrl, setWebViewUrl] = useState('')
  const [unreadMessage, setUnreadMessage] = useState<number>(0)
  const [category, setCategory] = useState<Category[]>([])
  const [sender, setSender] = useState<{ sender: string }[]>([])
  const [userCount, setUserCount] = useState(0)
  const [keyword, setKeyword] = useState<{
    sender: string
    category: string
    important_flg: string
    hot_news_flg: string
    close_flg: string
    post: string
    push: string
  }>({
    sender: '',
    category: '',
    important_flg: '',
    hot_news_flg: '',
    close_flg: '',
    post: '',
    push: ''
  })
  const config = useContext(ConfigContext)
  const fetchParams = { sort: ['release_date', 'id'], order: ['desc', 'desc'], limit: fetchLimit }

  const fetchData = async (params: QueryString) => {
    const { data } = await axios.get<{
      number_of_hits: number
      rows: Notification[]
      user_count: number
    }>('/notifications', {
      params: {
        ...fetchParams,
        ...params
      }
    })
    console.log(data)
    setNotifications(data.rows)
    setTotal(data.number_of_hits)
    setUserCount(data.user_count)
    if (data.number_of_hits > 0) {
      setLimit(fetchLimit)
    } else {
      setLimit(0)
    }
  }

  const fetchUnreadMessage = async () => {
    const { data } = await axios.get<MessageUserSearchResponse>('/messages/users/search')
    setUnreadMessage(data.unread_total)
  }

  const fetchSender = async () => {
    const { data } = await axios.get<{ sender: string }[]>('/notifications/sender')
    setSender(data)
  }

  const fetchCategory = async () => {
    const { data } = await axios.get<Category[]>(`/notifications/category`)
    setCategory(data)
  }

  useEffect(() => {
    try {
      fetchUnreadMessage()
      fetchSender()
      fetchCategory()
      if (
        searchQuery.page ||
        searchQuery.sender ||
        searchQuery.category ||
        searchQuery.important_flg ||
        searchQuery.hot_news_flg ||
        searchQuery.close_flg ||
        searchQuery.post ||
        searchQuery.push
      ) {
        const query: QueryString = { ...searchQuery }
        const urlQuery: QueryString = query
        for (let key in urlQuery) {
          if (!urlQuery[key]) {
            delete urlQuery[key]
          }
        }
        history.push({
          pathname: '/',
          search: queryString.stringify(urlQuery)
        })
        fetchData(searchQuery)
        setKeyword({ ...searchQuery })
      } else {
        initQuery.page = '1'
        fetchData(initQuery)
      }
      unsetSearchQuery()
    } catch (error) {
      alert(error.message)
    }
  }, [])

  const scrollPageTop = () =>
    document.getElementById('main-content').scroll({
      top: 0,
      left: 0
    })

  const handlePageChange = async (page: number) => {
    try {
      fetchSender()
      fetchCategory()
      const query: QueryString = {
        ...initQuery,
        page: String(page)
      }
      history.push({
        pathname: '/',
        search: queryString.stringify(query)
      })
      scrollPageTop()
      await fetchData(query)
    } catch (error) {
      alert(error.message)
    }
  }

  const handleSearch = async (key: string, select: string) => {
    try {
      const query: QueryString = {
        ...keyword,
        [key]: select,
        page: '1'
      }
      const urlQuery: QueryString = query
      for (let key in urlQuery) {
        if (!urlQuery[key]) {
          delete urlQuery[key]
        }
      }
      history.push({
        pathname: '/',
        search: queryString.stringify(urlQuery)
      })
      setKeyword({
        ...keyword,
        [key]: select
      })
      await fetchData(query)
      fetchSender()
      fetchCategory()
    } catch (error) {
      alert(error.message)
    }
  }

  const handleFilterReset = async () => {
    try {
      fetchSender()
      fetchCategory()
      setKeyword({
        sender: '',
        category: '',
        important_flg: '',
        hot_news_flg: '',
        close_flg: '',
        post: '',
        push: ''
      })
      history.push({
        pathname: '/'
      })
      const query: QueryString = {
        page: '1'
      }
      await fetchData(query)
    } catch (error) {
      alert(error.message)
    }
  }

  const currentPageCaption = () => {
    const totalNumber = total
    const currentPage = Number(initQuery.page) || 1
    const totalPage = Math.ceil(total / limit)
    const startNumber = totalNumber === 0 ? 0 : (currentPage - 1) * limit + 1
    const lastNumber = currentPage === totalPage ? totalNumber : currentPage * limit
    return (
      <Typography variant="caption" align="center" display="block" color="primary">
        全 {totalNumber} 件｜ ({startNumber} - {lastNumber}件)
      </Typography>
    )
  }

  const handleSubmit = async () => {
    try {
      setDialog(
        '確認',
        'メッセージは全ユーザー（退会者、非会員含む）に一斉送信されます。よろしいですか？',
        async () => {
          await axios.post('/notifications/pushall', {
            message: pushMessage
          })
        },
        () => {}
      )
    } catch (error) {
      alert(error.message)
    }
  }

  const handleCheckBoxChange = async (notificationId: number, key: string, checked: boolean) => {
    try {
      const { data } = await axios.put<Notification>(`/notifications/${notificationId}`, {
        [key]: checked
      })
      const _notifications = notifications.slice()
      notifications.forEach((notification, index) => {
        if (notification.id === notificationId) {
          _notifications[index] = data
        }
      })
      setNotifications(_notifications)
    } catch (error) {
      alert(error.message)
    }
  }

  const handleDelete = async (notificationId: number) => {
    try {
      setDialog(
        '確認',
        '削除してもよろしいですか？',
        async () => {
          await axios.delete(`/notifications/${notificationId}`)
          initQuery.page = initQuery.page ? initQuery.page : '1'
          fetchData(initQuery)
        },
        () => {}
      )
    } catch (error) {
      alert(error.message)
    }
  }

  const roundToOneDecimalPlace = (number: number) => {
    return Math.floor(number * 10) / 10
  }

  return (
    <React.Fragment>
      {unreadMessage > 0 && (
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Typography>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <ErrorRounded color="error" style={{ marginRight: 2, marginBottom: 2 }} />
                会員より新しいメッセージが届いています。
                <Link href="/messages?page=1&unreadfilter=1&pagescroll=1">ユーザーメッセージ</Link>
                からご確認ください。
              </div>
            </Typography>
          </Paper>
        </Grid>
      )}

      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Title>プッシュ通知送信</Title>
          <Box display="flex" justifyContent="space-between" mx={3}>
            <Box mr={3}>
              <Typography paragraph>
                全ユーザー（退会者、非会員含む）に対してプッシュ通知を送信することができます。メッセージを入力し「送信」ボタンを押してください。
              </Typography>
            </Box>
            <Box>
              <Button variant="contained" color="primary" href="/push-history">
                送信履歴
              </Button>
            </Box>
          </Box>
          <form noValidate onSubmit={event => event.preventDefault()}>
            <Box m={2}>
              <ValidationAndLimitLengthInput
                value={pushMessage}
                label="メッセージ"
                required={true}
                variant="outlined"
                fullWidth
                inputHandler={input => setPushMessage(input)}
                invalidStr={/["'<>&]/}
                strLength={100}
                validationErrorMessage='以下の記号類は、端末側で文字化けする可能性がありますので、使用しないでください。「"」「&#39;」「&lt;」「&gt;」「&amp;」'
                strLengthErrorMessage="メッセージ文字数が100文字を超えています。端末により100文字以降の文字が表示されない場合もございます、メッセージ文字数を調節してください。"
                validationStateChange={isFullFilled => {
                  setValidateState(isFullFilled)
                }}
              />
            </Box>
            <RightSideSubmitButton
              submittable={validateState && pushMessage.length > 0}
              resettable
              resetText="リセット"
              submitText="送信"
              submitHandler={handleSubmit}
              resetHandler={() => {
                setPushMessage('新しいお知らせがあります。')
              }}
            />
          </form>
        </Paper>
      </Grid>

      <Grid item xs={12}>
        <Paper className={classes.paper2}>
          <Title>お知らせ一覧</Title>

          <Box mb={5} display="flex" justifyContent="space-between" alignItems="center" mr={2}>
            <Button variant="contained" color="primary" href="/create-notification">
              お知らせの新規作成
            </Button>
            {config.enableNotificationsFilterReset === '1' && (
              <Badge
                className={classes.badge}
                badgeContent={<CancelIcon fontSize="small" />}
                invisible={Object.values(keyword).find(k => k !== '') ? false : true}
                max={0}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleFilterReset}
                  disabled={Object.values(keyword).find(k => k !== '') ? false : true}
                >
                  フィルターを解除
                </Button>
              </Badge>
            )}
          </Box>
          <Box my={4}>
            <Box display="flex" justifyContent="center">
              {currentPageCaption}
            </Box>
            <Box display="flex" justifyContent="center">
              <FlatPagination
                limit={limit}
                offset={(Number(initQuery.page || 1) - 1) * limit}
                total={total}
                onClick={(ev, offset, _page) => {
                  handlePageChange(_page)
                }}
              />
            </Box>
          </Box>

          <Table size="small" className={classes.table}>
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell align="center">
                  {config.enableNotificationsFilterPost === '1' ? (
                    <SelectInputTableHead
                      value={keyword.post}
                      label={'配信状況'}
                      selectHandler={(select: string) => handleSearch('post', select)}
                      options={[
                        { value: '', label: 'すべて表示' },
                        { value: '0', label: '配信中' },
                        { value: '1', label: '配信時間外' },
                        { value: '2', label: '配信停止中' }
                      ]}
                    />
                  ) : (
                    '配信状況'
                  )}
                </TableCell>
                <TableCell align="center">アイコン</TableCell>
                <TableCell>タイトル</TableCell>
                <TableCell>
                  {config.enableNotificationsFilterSender === '1' ? (
                    <SelectInputTableHead
                      value={keyword.sender}
                      label={'発信者'}
                      selectHandler={(select: string) => handleSearch('sender', select)}
                      options={[{ value: '', label: 'すべて表示' }].concat(
                        sender.map(d => {
                          return {
                            value: d.sender,
                            label: d.sender
                          }
                        })
                      )}
                    />
                  ) : (
                    '発信者'
                  )}
                </TableCell>
                <TableCell align="center">
                  開封数/ユーザー数<div>開封率</div>
                </TableCell>
                <TableCell align="center">掲載期間</TableCell>
                <TableCell align="center">
                  {category.length === 0 ? (
                    'カテゴリ'
                  ) : config.enableNotificationsFilterCategory === '1' ? (
                    <SelectInputTableHead
                      value={keyword.category}
                      label={'カテゴリ'}
                      selectHandler={(select: string) => handleSearch('category', select)}
                      options={[{ value: '', label: 'すべて表示' }].concat(
                        category.map(c => ({
                          value: String(c.id),
                          label: c.category
                        }))
                      )}
                    />
                  ) : (
                    'カテゴリ'
                  )}
                </TableCell>
                <TableCell align="center">
                  {config.enableNotificationsFilterHotNewsFlg === '1' ? (
                    <SelectInputTableHead
                      value={keyword.hot_news_flg}
                      label={'新着'}
                      selectHandler={(select: string) => handleSearch('hot_news_flg', select)}
                      options={[
                        { value: '', label: 'すべて表示' },
                        { value: '1', label: 'ON' },
                        { value: '0', label: 'OFF' }
                      ]}
                    />
                  ) : (
                    '新着'
                  )}
                </TableCell>
                <TableCell align="center">
                  {config.enableNotificationsFilterImportantFlg === '1' ? (
                    <SelectInputTableHead
                      value={keyword.important_flg}
                      label={'重要'}
                      selectHandler={(select: string) => handleSearch('important_flg', select)}
                      options={[
                        { value: '', label: 'すべて表示' },
                        { value: '1', label: 'ON' },
                        { value: '0', label: 'OFF' }
                      ]}
                    />
                  ) : (
                    '重要'
                  )}
                </TableCell>
                <TableCell align="center" style={{ paddingLeft: 0, paddingRight: 0 }}>
                  {config.enableNotificationsFilterCloseFlg === '1' ? (
                    <SelectInputTableHead
                      value={keyword.close_flg}
                      label={'表示/非表示'}
                      selectHandler={(select: string) => handleSearch('close_flg', select)}
                      options={[
                        { value: '', label: 'すべて表示' },
                        { value: '0', label: '表示中' },
                        { value: '1', label: '非表示' }
                      ]}
                    />
                  ) : (
                    '表示/非表示'
                  )}
                </TableCell>
                <TableCell align="center">編集</TableCell>
                <TableCell align="center">削除</TableCell>
                <TableCell align="center">プレビュー</TableCell>
                {config.enableNotificationArticlePush === '1' && (
                  <TableCell align="center">
                    {config.enableNotificationsFilterPush === '1' ? (
                      <SelectInputTableHead
                        value={keyword.push}
                        label={'通知送信'}
                        selectHandler={(select: string) => handleSearch('push', select)}
                        options={[
                          { value: '', label: 'すべて表示' },
                          { value: '0', label: '通知送信あり' },
                          { value: '1', label: '通知送信なし' }
                        ]}
                      />
                    ) : (
                      '通知送信'
                    )}
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody className={classes.tableBody}>
              {notifications.map((notification, index) => {
                const openRate = roundToOneDecimalPlace((notification.read_count * 100) / userCount)
                return (
                  <TableRow key={notification.id}>
                    <TableCell align="center">
                      {(() => {
                        if (notification.close_flg) {
                          return <Chip label="配信停止中" color="default" />
                        } else if (
                          moment() < moment(notification.release_date) ||
                          moment() >= moment(notification.close_date)
                        ) {
                          return <Chip label="配信期間外" color="default" />
                        } else {
                          return <Chip label="配信中" color="secondary" />
                        }
                      })()}
                    </TableCell>
                    <TableCell align="center">
                      <Avatar
                        src={`${config.serverHost}${notification.icon}`}
                        // s3対応
                        // src={
                        //   notification.icon === process.env.REACT_APP_NOIMAGE
                        //     ? config.serverHost + notification.icon
                        //     : `${config.serverHost}/upload/image/?key=${encodeURIComponent(
                        //         notification.icon
                        //       )}`
                        // }
                        alt={notification.icon}
                        className={classes.avatar}
                      />
                    </TableCell>
                    <TableCell align="left" style={{ width: '25%' }}>
                      <Typography variant="subtitle2">{notification.title}</Typography>
                    </TableCell>
                    <TableCell align="left">{notification.sender}</TableCell>
                    <TableCell align="center">
                      {userCount && (
                        <>
                          {notification.read_count}/{userCount}
                          <div>{openRate.toFixed(1)}%</div>
                        </>
                      )}
                    </TableCell>
                    <TableCell align="center">
                      <DatePeriodFragment
                        startTime={notification.release_date}
                        endTime={notification.close_date}
                      />
                    </TableCell>
                    <TableCell align="center">
                      {category.length > 0 &&
                        category.map(row => {
                          return row.id == notification.category && row.category
                        })}
                    </TableCell>
                    <TableCell align="center">
                      {Boolean(notification.hot_news_flg) ? 'ON' : 'OFF'}
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        color={Boolean(notification.important_flg) ? 'primary' : 'default'}
                        onClick={() => {
                          handleCheckBoxChange(
                            notification.id,
                            'important_flg',
                            !notification.important_flg
                          )
                        }}
                      >
                        {Boolean(notification.important_flg) ? 'ON' : 'OFF'}
                      </Button>
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        color={!Boolean(notification.close_flg) ? 'primary' : 'default'}
                        onClick={() => {
                          handleCheckBoxChange(
                            notification.id,
                            'close_flg',
                            !notification.close_flg
                          )
                        }}
                      >
                        {!Boolean(notification.close_flg) ? '表示中' : '非表示'}
                      </Button>
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        color="primary"
                        href={`edit-notification/${notification.id}`}
                        onClick={() =>
                          setSearchQuery(
                            initQuery.page,
                            initQuery.sender,
                            initQuery.category,
                            initQuery.important_flg,
                            initQuery.hot_news_flg,
                            initQuery.close_flg,
                            initQuery.post,
                            initQuery.push
                          )
                        }
                      >
                        編集
                      </Button>
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleDelete(notification.id)}
                      >
                        削除
                      </Button>
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          if (notification.external_link) {
                            alert(
                              '外部サイトへのリンクが設置されています。\nリンク先の確認は「編集」よりお願いします。'
                            )
                          } else if (notification.file_link) {
                            alert(
                              'ファイルリンクが設置されています。\nファイルの確認は「編集」よりお願いします。'
                            )
                          } else {
                            setWebViewUrl(
                              `${axios.defaults.baseURL}/previews/notifications/${notification.id}`
                            )
                            setModalState(true)
                          }
                        }}
                      >
                        プレビュー
                      </Button>
                    </TableCell>
                    {config.enableNotificationArticlePush === '1' && (
                      <TableCell align="center">
                        <Box>
                          <Button
                            variant="contained"
                            color={
                              notification.push_at || notification.push_reserved_date
                                ? 'primary'
                                : 'default'
                            }
                            onClick={() =>
                              setModalStatePush({
                                notificationId: notification.id,
                                isOpen: true
                              })
                            }
                          >
                            通知送信
                          </Button>
                          {!notification.push_at && notification.push_reserved_date && (
                            <Box marginBottom="-35px">
                              <Typography variant="caption" color="secondary">
                                配信予約 :
                                <br />
                                <Typography noWrap style={{ fontSize: 'inherit', marginTop: -5 }}>
                                  {moment(notification.push_reserved_date).format('YYYY/M/D HH:mm')}
                                </Typography>
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </TableCell>
                    )}
                  </TableRow>
                )
              }, initQuery)}
            </TableBody>
          </Table>

          <Box my={4}>
            <Box display="flex" justifyContent="center">
              {currentPageCaption}
            </Box>
            <Box display="flex" justifyContent="center">
              <FlatPagination
                limit={limit}
                offset={(Number(initQuery.page || 1) - 1) * limit}
                total={total}
                onClick={(ev, offset, _page) => {
                  handlePageChange(_page)
                }}
              />
            </Box>
          </Box>
        </Paper>
      </Grid>
      <WebViewModal isOpen={modalState} handleClose={() => setModalState(false)} url={webViewUrl} />
      <NotificationPushModal
        notificationId={modalStatePush.notificationId}
        isOpen={modalStatePush.isOpen}
        closeHandler={() => {
          setModalStatePush({ notificationId: null, isOpen: false })
          initQuery.page = initQuery.page ? initQuery.page : '1'
          fetchData(initQuery)
        }}
      />
    </React.Fragment>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setDialog: (title: string, content: string, okHandler: () => void, ngHandler: () => void) =>
      dispatch(setDialog(title, content, okHandler, ngHandler)),
    setSearchQuery: (
      page: string,
      sender: string,
      category: string,
      important_flg: string,
      hot_news_flg: string,
      close_flg: string,
      status: string,
      push: string
    ) =>
      dispatch(
        setSearchQuery(
          page,
          sender,
          category,
          important_flg,
          hot_news_flg,
          close_flg,
          status,
          push,
          ''
        )
      ),
    unsetSearchQuery: () => dispatch(unsetSearchQuery())
  }
}

const mapStateToProps = (state: ReturnType<typeof store.getState>) => {
  return {
    searchQuery: state.searchQuery
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Notifications)
